import { useSelector } from 'react-redux';
import { selectors as coreSelectors } from 'mage-core';
export const useChatClient = () => {
    const createClient = useSelector(coreSelectors.createBackendClient);
    return createClient('support-chat');
};
